/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */
let hostname = window.location.hostname;

export const commonConstants = {
  IS_PRODUCTION_SITE: hostname.includes('autire.ai'),
  USER_ACCOUNT_UTILS_API: 'UserAccountUtils_Master',
  PLAN_LEVEL_AUDIT_TEST_ATTRIBUTES_API: 'PlanLevelAuditTestAttributes_Master',
  PLAN_LEVEL_UTILS_API: 'PlanLevelUtils_Master',
  PLAN_SPONSERS_API: 'planSponsors_Master',
  PLAN_LEVEL_AUTHORING_API: 'PlanLevelAuthoring_Master',
  AUDIT_TEST_API: 'auditTest_Master',
  AUDIT_WRAP_API: 'auditWrap_Master',
  DOCUMENTS_API: 'documents_Master',
  INSIGHTS_API: 'insights_Master',
  COMMUNICATION_API: 'communication_Master',
  RISK_ANALYSIS_API: 'riskAnalysis_Master',
  AUDIT_COMMUNICATION_API: 'auditCommunication_Master',
  AUDITOR_API: 'auditor_Master',
  AUDITOR_V2_API: 'auditorV2Lambda_Master',
  AUDITOR_V3_API: 'auditorV3Lambda_Master',
  MIGRATE_MULTI_MODULE_API: true,
  MULTI_MODULE_API: 'MultiModuleUtils_Master',
  MIGRATE_IMPORT_LAMBDA_API: true,
  IMPORT_DATA_API: 'ImportData_Master',
  IMPORT_DATA_SYNC_API: 'ImportDataSync_Master',
  MANAGEMENT_INQUIRIES_API: 'ManagementInquiries_Master',
  FRAUD_MEMO_API: 'FraudMemo_Master',
  UAC_API: 'UAC_Master',
  /** Amplify REST apiName; maps to .../uac/ (Unified Audit Communication). */
  UNIFIED_AUDIT_COMMUNICATION_API: 'UnifiedAuditCommunication_Master',
  BROADCAST_API: 'Broadcast_Master',

  PLAN_INFO_FETCH_SUCCESS: 'PLAN_INFO_FETCH_SUCCESS',
  PLAN_INFO_RESET: 'PLAN_INFO_RESET',
  PLAN_INFO_INITIAL: 'PLAN_INFO_INITIAL',

  PLAN_CONTACT_FETCH_SUCCESS: 'PLAN_CONTACT_FETCH_SUCCESS',
  SERVICE_PROVIDER_FETCH_SUCCESS: 'SERVICE_PROVIDER_FETCH_SUCCESS',
  PLAN_CHECKUP_FETCH_SUCCESS: 'PLAN_CHECKUP_FETCH_SUCCESS',
  PLAN_CHECKUP_RESET: 'PLAN_CHECKUP_RESET',
  ENGAGE_LETTER_FETCH_SUCCESS: 'ENGAGE_LETTER_FETCH_SUCCESS',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  INSIGHT_FETCH_SUCCESS: 'INSIGHT_FETCH_SUCCESS',
  PLAN_DOCUMENTS_FETCH_SUCCESS: 'PLAN_DOCUMENTS_FETCH_SUCCESS',
  RESET_PLAN_DOCUMENTS: 'RESET_PLAN_DOCUMENTS',
  REPORT_DOCUMENTS_FETCH_SUCCESS: 'REPORT_DOCUMENTS_FETCH_SUCCESS',
  RESET_REPORT_DOCUMENTS: 'RESET_REPORT_DOCUMENTS',
  PAYROLL_FETCH_SUCCESS: 'PAYROLL_FETCH_SUCCESS',
  COMMON_PAYROLL_FETCH_SUCCESS: 'COMMON_PAYROLL_FETCH_SUCCESS',
  PAYROLL_RESET: 'PAYROLL_RESET',
  SET_SELECTED_EMPLOYEE: 'SET_SELECTED_EMPLOYEE',
  TEST_OPTIONS_FETCH_SUCCESS: 'TEST_OPTIONS_FETCH_SUCCESS',
  MANAGE_LETTER_FETCH_SUCCESS: 'MANAGE_LETTER_FETCH_SUCCESS',

  RESET_DEPLOYED_AUDIT_STEP_GROUPS: 'RESET_DEPLOYED_AUDIT_STEP_GROUPS',
  UPDATE_DEPLOYED_AUDIT_STEP_GROUPS: 'UPDATE_DEPLOYED_AUDIT_STEP_GROUPS',
  AUDIT_PROGRESS_FETCH_SUCCESS: 'AUDIT_PROGRESS_FETCH_SUCCESS',
  AUDIT_PROGRESS_FETCH_RESET: 'AUDIT_PROGRESS_FETCH_RESET',
  AUDIT_STEP_FETCH_SUCCESS: 'AUDIT_STEP_FETCH_SUCCESS',
  AUDIT_STEP_RESET: 'AUDIT_STEP_RESET',
  AUDIT_NEW_PROGRESS_FETCH_SUCCESS: 'AUDIT_NEW_PROGRESS_FETCH_SUCCESS',
  AUDIT_NEW_PROGRESS_FETCH_RESET: 'AUDIT_NEW_PROGRESS_FETCH_RESET',
  AUDIT_STEP_NEW_FETCH_SUCCESS: 'AUDIT_STEP_NEW_FETCH_SUCCESS',
  AUDIT_STEP_NEW_RESET: 'AUDIT_STEP_NEW_RESET',
  SET_LOGIN_USER: 'SET_LOGIN_USER',
  SET_USER_AUTHORIZATIONS: 'SET_USER_AUTHORIZATIONS',

  XRAY_FETCH_SUCCESS: 'XRAY_FETCH_SUCCESS',
  XRAY_FETCH_PROGRESS: 'XRAY_FETCH_PROGRESS',
  XRAY_RESET: 'XRAY_RESET',

  TRIAL_BALANCE_FETCH_SUCCESS: 'TRIAL_BALANCE_FETCH_SUCCESS',
  TRIAL_BALANCE_FETCH_PROGRESS: 'TRIAL_BALANCE_FETCH_PROGRESS',
  TRIAL_BALANCE_FETCH_FAILURE: 'TRIAL_BALANCE_FETCH_FAILURE',

  PLANS_FETCH_SUCCESS: 'PLANS_FETCH_SUCCESS',
  PLANS_FETCH_PROGRESS: 'PLANS_FETCH_PROGRESS',
  PLANS_FETCH_FAILED: 'PLANS_FETCH_FAILED',

  SET_COPY_LOG: 'SET_COPY_LOG',
  RESET_COPY_LOG: 'RESET_COPY_LOG',

  IS_DASHBOARD_ON: 'IS_DASHBOARD_ON',
  IS_DASHBOARD_OFF: 'IS_DASHBOARD_OFF',

  SET_PLAN_NAME_N_YEAR: 'SET_PLAN_NAME_N_YEAR',
  RESET_PLAN_NAME_N_YEAR: 'RESET_PLAN_NAME_N_YEAR',

  JOURNAL_ENTRIES_FETCH_SUCCESS: 'JOURNAL_ENTRIES_FETCH_SUCCESS',
  JOURNAL_ENTRIES_FETCH_FAILURE: 'JOURNAL_ENTRIES_FETCH_FAILURE',

  SET_DISCLOSER_NOTES: 'SET_DISCLOSER_NOTES',
  SET_DISCLOSER_NOTES_PROGRESS: 'SET_DISCLOSER_NOTES_PROGRESS',
  RESET_DISCLOSER_NOTES: 'RESET_DISCLOSER_NOTES',
  SET_INTERNAL_CONTROL_NOTES: 'SET_INTERNAL_CONTROL_NOTES',
  SET_INTERNAL_CONTROL_NOTES_PROGRESS: 'SET_INTERNAL_CONTROL_NOTES_PROGRESS',
  RESET_INTERNAL_CONTROL_NOTES: 'RESET_INTERNAL_CONTROL_NOTES',

  SET_RISK_ASSERTION_DATA: 'SET_RISK_ASSERTION_DATA',
  SET_RISK_ASSERTION_DATA_PROGRESS: 'SET_RISK_ASSERTION_DATA_PROGRESS',
  RESET_RISK_ASSERTION_DATA: 'RESET_RISK_ASSERTION_DATA',

  SET_INTERNAL_CONTROL_RISK_DATA: 'SET_INTERNAL_CONTROL_RISK_DATA',
  SET_INTERNAL_CONTROL_RISK_DATA_PROGRESS: 'SET_INTERNAL_CONTROL_RISK_DATA_PROGRESS',
  RESET_INTERNAL_CONTROL_RISK_DATA: 'RESET_INTERNAL_CONTROL_RISK_DATA',

  SET_PRELIMINARY_ANALYTICS_RISK_DATA: 'SET_PRELIMINARY_ANALYTICS_RISK_DATA',
  SET_PRELIMINARY_ANALYTICS_RISK_DATA_PROGRESS: 'SET_PRELIMINARY_ANALYTICS_RISK_DATA_PROGRESS',
  RESET_PRELIMINARY_ANALYTICS_RISK_DATA: 'RESET_PRELIMINARY_ANALYTICS_RISK_DATA',

  SET_FRAUD_RISK_DATA: 'SET_FRAUD_RISK_DATA',
  SET_FRAUD_RISK_DATA_PROGRESS: 'SET_FRAUD_RISK_DATA_PROGRESS',
  RESET_FRAUD_RISK_DATA: 'RESET_FRAUD_RISK_DATA',

  SET_CURRENT_SELECTED_RISK_DATA: 'SET_CURRENT_SELECTED_RISK_DATA',
  RESET_CURRENT_SELECTED_RISK_DATA: 'RESET_CURRENT_SELECTED_RISK_DATA',

  SET_INTERNAL_CONTROL_RISK_DETAILS_DATA: 'SET_INTERNAL_CONTROL_RISK_DETAILS_DATA',
  SET_INTERNAL_CONTROL_RISK_DETAILS_DATA_PROGRESS:
    'SET_INTERNAL_CONTROL_RISK_DETAILS_DATA_PROGRESS',
  RESET_INTERNAL_CONTROL_RISK_DETAILS_DATA: 'RESET_INTERNAL_CONTROL_RISK_DETAILS_DATA',

  SET_AUDIT_STEP_RISK_DATA: 'SET_AUDIT_STEP_RISK_DATA',
  SET_AUDIT_STEP_RISK_DATA_PROGRESS: 'SET_AUDIT_STEP_RISK_DATA_PROGRESS',
  RESET_AUDIT_STEP_RISK_DATA: 'RESET_AUDIT_STEP_RISK_DATA',

  SET_SOC_ONE_RISK_DATA: 'SET_SOC_ONE_RISK_DATA',
  SET_SOC_ONE_RISK_DATA_PROGRESS: 'SET_SOC_ONE_RISK_DATA_PROGRESS',
  RESET_SOC_ONE_RISK_DATA: 'RESET_SOC_ONE_RISK_DATA',

  SET_DOCUMENT_ID: 'SET_DOCUMENT_ID',

  IS_RISK_ANALYSIS_TAB_ACTIVE: 'IS_RISK_ANALYSIS_TAB_ACTIVE',
  IS_RISK_ANALYSIS_TAB_INACTIVE: 'IS_RISK_ANALYSIS_TAB_INACTIVE',

  SET_RISK_SAMPLE_SIZE_EFFECT_DATA: 'SET_RISK_SAMPLE_SIZE_EFFECT_DATA',
  SET_RISK_SAMPLE_SIZE_EFFECT_DATA_PROGRESS: 'SET_RISK_SAMPLE_SIZE_EFFECT_DATA_PROGRESS',
  RESET_RISK_SAMPLE_SIZE_EFFECT_DATA: 'RESET_RISK_SAMPLE_SIZE_EFFECT_DATA',

  IS_PARTIPANT_VIEW_TAB_ACTIVE: 'IS_PARTIPANT_VIEW_TAB_ACTIVE',
  IS_PARTIPANT_VIEW_TAB_INACTIVE: 'IS_PARTIPANT_VIEW_TAB_INACTIVE',

  SET_INDEPENDENCE_CONSIDERATION_DATA: 'SET_INDEPENDENCE_CONSIDERATION_DATA',
  RESET_INDEPENDENCE_CONSIDERATION_DATA: 'RESET_INDEPENDENCE_CONSIDERATION_DATA',

  SET_AUDIT_COMMUNICATION_DATA: 'SET_AUDIT_COMMUNICATION_DATA',
  SET_AUDIT_COMMUNICATION_DATA_PROGRESS: 'SET_AUDIT_COMMUNICATION_DATA_PROGRESS',
  RESET_AUDIT_COMMUNICATION_DATA: 'RESET_AUDIT_COMMUNICATION_DATA',

  SET_AUDIT_COMMUNICATION_LABELS_DATA: 'SET_AUDIT_COMMUNICATION_LABELS_DATA',
  SET_AUDIT_COMMUNICATION_LABELS_DATA_PROGRESS: 'SET_AUDIT_COMMUNICATION_LABELS_DATA_PROGRESS',
  RESET_AUDIT_COMMUNICATION_LABELS_DATA: 'RESET_AUDIT_COMMUNICATION_LABELS_DATA',

  SET_AUDIT_COMMUNICATION_DETAILS_DATA: 'SET_AUDIT_COMMUNICATION_DETAILS_DATA',
  SET_AUDIT_COMMUNICATION_DETAILS_DATA_PROGRESS: 'SET_AUDIT_COMMUNICATION_DETAILS_DATA_PROGRESS',
  RESET_AUDIT_COMMUNICATION_DETAILS_DATA: 'RESET_AUDIT_COMMUNICATION_DETAILS_DATA',

  SET_RISK_ASSESSMENT_DATA: 'SET_RISK_ASSESSMENT_DATA',
  SET_RISK_ASSESSMENT_DATA_PROGRESS: 'SET_RISK_ASSESSMENT_DATA_PROGRESS',
  RESET_RISK_ASSESSMENT_DATA: 'RESET_RISK_ASSESSMENT_DATA',

  SET_RISK_ASSESSMENT_GROUP_DATA: 'SET_RISK_ASSESSMENT_GROUP_DATA',
  SET_RISK_ASSESSMENT_GROUP_DATA_RESET: 'SET_RISK_ASSESSMENT_GROUP_DATA_RESET',

  SET_CURRENT_SELECTED_RISK_ASSESSMENT_DATA: 'SET_CURRENT_SELECTED_RISK_ASSESSMENT_DATA',
  RESET_CURRENT_SELECTED_RISK_ASSESSMENT_DATA: 'RESET_CURRENT_SELECTED_RISK_ASSESSMENT_DATA',

  SET_MANAGEMENT_INQUIRY_DETAILS_DATA_PROGRESS: 'SET_MANAGEMENT_INQUIRY_DETAILS_DATA_PROGRESS',
  SET_MANAGEMENT_INQUIRY_DETAILS_DATA: 'SET_MANAGEMENT_INQUIRY_DETAILS_DATA',

  SET_FRAUD_SPECIFIC_RISK_DETAILS_DATA: 'SET_FRAUD_SPECIFIC_RISK_DETAILS_DATA',
  SET_FRAUD_SPECIFIC_RISK_DETAILS_DATA_PROGRESS: 'SET_FRAUD_SPECIFIC_RISK_DETAILS_DATA_PROGRESS',

  IS_REVIEW_MODE_ON: 'IS_REVIEW_MODE_ON',
  IS_REVIEW_MODE_OFF: 'IS_REVIEW_MODE_OFF',

  FINAL_DELIVERABLES_SUCCESS: 'FINAL_DELIVERABLES_SUCCESS',
  FINAL_DELIVERABLES_RESET: 'FINAL_DELIVERABLES_RESET',

  SET_GLOBAL_SETTINGS: 'SET_GLOBAL_SETTINGS',

  PLAN_EMAIL_STATUS_FETCH_SUCCESS: 'PLAN_EMAIL_STATUS_FETCH_SUCCESS',
  PLAN_EMAIL_STATUS_RESET: 'PLAN_EMAIL_STATUS_RESET',

  AUDIT_STEP_LOGS: 'AUDIT_STEP_LOGS',
  AUDIT_STEP_LOGS_RESET: 'AUDIT_STEP_LOGS_RESET',

  SET_PAA_LOANS_ALLOWED: 'SET_PAA_LOANS_ALLOWED',

  SET_CONTROL_DEFICIENCIES_DATA: 'SET_CONTROL_DEFICIENCIES_DATA',
  SET_CONTROL_DEFICIENCIES_DATA_PROGRESS: 'SET_CONTROL_DEFICIENCIES_DATA_PROGRESS',
  RESET_CONTROL_DEFICIENCIES_DATA: 'RESET_CONTROL_DEFICIENCIES_DATA',

  SET_PLAN_CONTROL_DEFICIENCIES_DATA: 'SET_PLAN_CONTROL_DEFICIENCIES_DATA',
  SET_PLAN_CONTROL_DEFICIENCIES_DATA_PROGRESS: 'SET_PLAN_CONTROL_DEFICIENCIES_DATA_PROGRESS',
  RESET_PLAN_CONTROL_DEFICIENCIES_DATA: 'RESET_PLAN_CONTROL_DEFICIENCIES_DATA',

  SET_PLANS_FOR_COMMUNICATION: 'SET_PLANS_FOR_COMMUNICATION',
  SET_PLANS_FOR_COMMUNICATION_PROGRESS: 'SET_PLANS_FOR_COMMUNICATION_PROGRESS',
  RESET_PLANS_FOR_COMMUNICATION: 'RESET_PLANS_FOR_COMMUNICATION',

  RESET_PLAN_LOGO: 'RESET_PLAN_LOGO',
  SET_PLAN_LOGO: 'SET_PLAN_LOGO',

  SET_PLAN_LEVEL_CONFIG: 'SET_PLAN_LEVEL_CONFIG',

  IS_SECOND_REVIEW_MODE_ON: 'IS_SECOND_REVIEW_MODE_ON',
  IS_SECOND_REVIEW_MODE_OFF: 'IS_SECOND_REVIEW_MODE_OFF',

  SET_CPA: 'SET_CPA',
  SET_CPA_LIST: 'SET_CPA_LIST',
};

export const winscpOtpFlags = {
  DISPLAY_WINSCP_OTP: 'DISPLAY_WINSCP_OTP',
  HIDE_WINSCP_OTP: 'HIDE_WINSCP_OTP',
};

export const asideMenuFlag = {
  ASIDE_MENU_OPEN: 'ASIDE_MENU_OPEN',
  ASIDE_MENU_CLOSE: 'ASIDE_MENU_CLOSE',
};

export const reviewscreenFlag = {
  REVIEW_SCREEN_OPEN: 'REVIEW_SCREEN_OPEN',
  REVIEW_SCREEN_CLOSE: 'REVIEW_SCREEN_CLOSE',
};

export const variableConstants = {
  COMBINED_UNIT_ID: 99999,
};

export const sideBarCostants = {
  SHOW_SIDEBAR: 'SHOW_SIDEBAR',
  SIDEBAR_UNFOLDED: 'SIDEBAR_UNFOLDED',
};

export const moduleName = {
  AUDIT_VARIABLE_GROUP: 'VariableConfig',
  AUDIT_VARIABLE: 'AuditVariables',

  //Audit step
  AUDIT_STEP_GROUP: 'AuditStepGroup',
  AUDIT_STEP: 'AuditStep',

  //Attribute Testing
  ATTRIBUTE_TEST_GROUP: 'AuditTestAttributeGroup',
  ATTRIBUTE_TEST: 'AuditTestAttributes',

  //Service Provider
  SERVICE_PROVIDER: 'ServiceProvider',

  //QCM & Firm Methodology
  FIRM_METHODOLOGY: 'FirmMethodology',
  QCM: 'QCM',

  // Management Inquiries
  MANAGEMENT_INQUIRY_QUESTIONS: 'ManagementInquiryQuestions',
  MANAGEMENT_INQUIRY_ROLES: 'ManagementInquiryRoles',

  // Fraud Memo
  FRAUD_MEMO: 'FraudMemo',
  DISCLOSURE_NOTES: 'DisclosureNotes',
  REPORTABLE_FINDINGS: 'ReportableFindings',

  //Control Environment
  CONTROL_ENVIRONMENT_GROUP: 'ControlEnvironmentGroup',
  CONTROL_ENVIRONMENT_QUESTION: 'ControlEnvironmentQuestions',

  // UAC
  UAC_TEMPLATES: 'UACTemplates',
  UAC_REMINDERS: 'UACReminders',
  UAC_TOPICS: 'UACTopics',
  UAC_HASHTAGS: 'UACHashtags',

  DISCLOSURE_NOTES_PLAN_TO_MASTER: 'DisclosureNotesPlanToMaster',
  REPORTABLE_FINDINGS_PLAN_TO_MASTER: 'ReportableFindingsMasterToPlan',
  QCM_MASTER_TO_PLAN: 'QCMMasterToPlan',
  FIRM_METHODOLOGY_MASTER_TO_PLAN: 'FirmMethodologyMasterToPlan',
  AUDIT_VARIABLE_PLAN_TO_MASTER: 'MasterVariableToPlanCopy',
  AUDIT_STEP_PLAN_TO_MASTER: 'AuditStepMasterToPlan',
  CONTROL_ENVIRONMENT_PLAN_TO_MASTER: 'ControlEnvironmentPlanToMaster',
  ATTRIBUTE_TESTING_PLAN_TO_MASTER: 'AttributeTestMasterToPlan',
  MANAGEMENT_INQUIRIES_PLAN_TO_MASTER: 'ManagementInquiryMasterToPlan',
  FRAUD_MEMO_PLAN_TO_MASTER: 'FraudMemoMasterToPlan',
  DYNAMIC_DOCUMENT_PLAN_TO_MASTER: 'DynamicDocumentMasterToPlan',
  UAC_PLAN_TO_MASTER: 'UACMasterToPlan',
};

export const serviceNamePushToCPA = {
  AUDIT_STEP_PUSH_TO_CPA: 'AuditStepAuthoringCopy',
  ATTRIBUTE_TEST_PUSH_TO_CPA: 'AuditTestAttributeAuthoringCopy',
  CONTROL_ENVIRONMENT_PUSH_TO_CPA: 'ControlEnvironmentAuthoringCopy',
  DISCLOSURE_NOTES_PUSH_TO_CPA: 'DisclosureNotesAuthoringCopy',
  INTERNAL_CONTROL_NOTES_PUSH_TO_CPA: 'InternalControlNotesAuthoringCopy',
  MANAGEMENT_INQUIRY_PUSH_TO_CPA: 'RiskAssessmentManagementInquiryAuthoringCopy',
  RISK_ASSESSMENT_NOTES_PUSH_TO_CPA: 'RiskAssessmentManagementInquiryRolesAuthoringCopy',
};

export function encrypt(d) {
  let a = '';
  const b = Math.floor(Math.random() * 9) + 1;
  const c = Math.random();
  let k = [...Array(95).keys()].map((n) => {
    return n + 32;
  });
  for (let i = k.length - 1; i > 0; i--)
    [k[i], k[Math.floor(c * (i + 1))]] = [k[Math.floor(c * (i + 1))], k[i]];
  d = typeof d === 'object' && !Array.isArray(d) && d !== null ? JSON.stringify(d) : d;
  for (var i = 0; i < d.length; i++)
    a += k.includes(d.charCodeAt(i))
      ? String.fromCharCode(
          k[
            k.indexOf(d.charCodeAt(i)) + b > k.length - 1
              ? k.indexOf(d.charCodeAt(i)) + b - k.length
              : k.indexOf(d.charCodeAt(i)) + b
          ]
        )
      : d.charAt(i);
  return { r: b + c.toFixed(16).replace('0.', '0') + a };
}

export function decrypt(d) {
  let a = '';
  const b = d.substring(0, 1);
  const c = d.substring(1, 18).replace('0', '0.');
  d = d.substr(18);
  let k = [...Array(95).keys()].map((n) => {
    return n + 32;
  });
  for (let i = k.length - 1; i > 0; i--)
    [k[i], k[Math.floor(c * (i + 1))]] = [k[Math.floor(c * (i + 1))], k[i]];
  for (var i = 0; i < d.length; i++)
    a += k.includes(d.charCodeAt(i))
      ? String.fromCharCode(
          k[
            k.indexOf(d.charCodeAt(i)) - b >= 0
              ? k.indexOf(d.charCodeAt(i)) - b
              : k.length + (k.indexOf(d.charCodeAt(i)) - b)
          ]
        )
      : d.charAt(i);
  return a;
}

export const EulaContent = `<p class="MsoNormal" align="center" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:
auto;text-align:center;mso-outline-level:1"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">SOFTWARE END USER LICENSE
AGREEMENT<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">This Software License Agreement (the “Agreement”),
is between you, the user (“Licensee”) and Autire Technologies, LLC, a Texas
limited liability company (“Licensor”).<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">BY ACCEPTING THIS AGREEMENT, EITHER BY INDICATING
YOUR ACCEPTANCE OR BY DOWNLOADING, INSTALLING AND/OR UTILIZING THE SOFTWARE
(DEFINED BELOW), YOU AGREE TO THIS AGREEMENT. THIS AGREEMENT IS A LEGALLY
BINDING CONTRACT BETWEEN YOU AND LICENSOR AND SETS FORTH THE TERMS THAT GOVERN
THE LICENSE PROVIDED TO YOU HEREUNDER. ANY CHANGES, ADDITIONS OR DELETIONS BY
YOU TO THIS AGREEMENT WILL NOT BE ACCEPTED AND WILL NOT BE A PART OF THIS
AGREEMENT. IF YOU DO NOT AGREE TO THIS AGREEMENT, YOU MUST NOT DOWNLOAD,
INSTALL, OR USE THE SOFTWARE.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Licensee’s access to the Software is governed by a
Master Software License Agreement (the “MSA”), which is incorporated herein,
and which is binding on Licensee. In addition, this Agreement incorporates, by
reference, the following agreements, policies, and terms, each as amended by
Licensor from time to time, and which are binding on Licensee:<o:p></o:p></span></p><p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.25pt;margin-left:
0cm;text-align:justify;text-indent:36.0pt"><span lang="EN-US" style="font-size:
10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#444444">Privacy Policy&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span lang="EN-US"><a  target="_blank" href="https://www.iubenda.com/privacy-policy/30234749"><span style="font-size:
10.0pt;mso-bidi-font-size:12.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:
EN-IN">https://www.iubenda.com/privacy-policy/30234749</span></a></span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;"> </span><span lang="EN-US" style="font-size:10.0pt;
font-family:&quot;Arial&quot;,sans-serif;color:#444444"><o:p></o:p></span></p><p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.25pt;margin-left:
0cm;text-align:justify;text-indent:36.0pt"><span lang="EN-US" style="font-size:
10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#444444">Cookie Policy</span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span lang="EN-US"><a  target="_blank" href="https://www.iubenda.com/privacy-policy/30234749/cookie-policy"><span style="font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:&quot;Arial&quot;,sans-serif;
mso-fareast-language:EN-IN">https://www.iubenda.com/privacy-policy/30234749/cookie-policy</span></a></span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;"><o:p></o:p></span></p><p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.25pt;margin-left:
0cm;text-align:justify;text-indent:36.0pt"><span lang="EN-US" style="font-size:
10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#444444">Terms of Use&nbsp;&nbsp;&nbsp; </span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span lang="EN-US"><a  target="_blank" href="https://www.iubenda.com/terms-and-conditions/30234749"><span style="font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:&quot;Arial&quot;,sans-serif;
mso-fareast-language:EN-IN">https://www.iubenda.com/terms-and-conditions/30234749</span></a></span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;"> <o:p></o:p></span></p><p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.25pt;margin-left:
0cm;text-align:justify"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1. LICENSE.<o:p></o:p></span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.1 Software
License Grant.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Subject to this Agreement, Licensor grants to
Licensee a perpetual, non–exclusive software license to use Licensor's “Autire”
software application, and all manuals, revisions, updates and improvements, and
all related data, instructions, information and materials related thereto
(collectively, the “Software”), for Licensee's business purposes. Nothing
herein shall prohibit Licensor from licensing or granting other rights in and
to the Software to other parties. Unauthorized use of the Software including,
but not limited to, unauthorized access, sharing of logins, misuse of
passwords, or misuse of any information or Software elements, tools or
functions, is strictly prohibited<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.2 Copies.&nbsp; – </span></b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Licensee agrees to use reasonable commercial
efforts to protect the Software, including its source code, object code,
algorithms and source documentation from unauthorized copying, disclosure or
use.&nbsp; Licensee will not share logins,
screen shots, or reports produced by the Software except as provided in this
Agreement and the MSA.<b><o:p></o:p></b></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.3 Ownership.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">All right, title and interest in and to the
Software and any and all copies thereof including without limitation, all
copyright, patent and other proprietary rights therein, will, at all times,
exclusively be owned by Licensor. Licensee agrees to execute any assignments or
other documentation requested by Licensor to fully vest in or confirm
Licensor's title to such property. All data and materials created by Licensee
using the Software shall be owned by Licensee.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif">Licensee hereby
grants to Licensor and its affiliates a non-exclusive, perpetual, irrevocable,
worldwide license to use, sample, collect, and compile Licensee Data in
aggregated, de-identified form for the purposes of providing or maintenance of,
improvement to, and operation of the Software or Services or for any new or
different products or services.&nbsp;&nbsp; In
addition, to Licensee grants to Licensor the right to sub-license to third
parties the Licensee Data in a de-identified form for the purposes of
improvements to Software and for similar Licensor business purposes.</span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.4 Restrictions.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Except as expressly authorized in this Agreement,
Licensee may not sublicense, rent, lease, distribute, transfer or transmit the
Software or any portion thereof. Furthermore, Licensee shall not, and shall not
permit third parties, to (a) copy, except as expressly provided in this
Agreement, (b) modify or create derivative works of the Software and
documentation, (c) reverse engineer, decompile, reverse translate or in any way
derive any source code or trade secrets from the Software, or (d) merge or
embed the Software into any other computer program.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.5 Licensee Obligations.&nbsp; <o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Licensee shall be solely responsible for the
accuracy, quality and legality of Licensee Data entered into or transmitted to
the Software and the means by which it was originally obtained. Licensee shall
use commercially reasonable efforts to prevent unauthorized access to or use of
the Software and shall notify Licensor promptly of any actual unauthorized
access or use. Licensee shall use the Software in compliance with US and applicable
local laws, including export control laws, and shall not use the Software to
store or transmit any illegal material. Licensee shall be solely responsible
for the retention of all original source Licensee Data. Licensee shall not
attempt to gain unauthorized access to or circumvent any access or tracking
mechanism for the Software. <o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.6 DISCLAIMER<o:p></o:p></span></b></p><p class="MsoNormal" style="margin-top:0cm;margin-right:6.8pt;margin-bottom:10.0pt;
margin-left:0cm;text-align:justify;mso-pagination:none;mso-layout-grid-align:
none;text-autospace:none"><b><span lang="EN-US" style="font-size:10.0pt;
font-family:&quot;Arial&quot;,sans-serif;color:black;mso-themecolor:text1">The Site Does
Not Provide Legal, Financial, Business or Tax Advice. </span></b><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">All of the contents of the Software, such as text,
graphics, images, charts, reports, formulae, content, and other material
contained in or produced by the Software are for informational purposes only.
The content is not intended to be a substitute for professional legal,
financial, business or tax advice. Always seek the advice of a qualified professionals
for any issues or questions you may have regarding such matters. Reliance on
any information provided by Software is expressly at your own risk. <o:p></o:p></span></p><p class="MsoNormal" style="margin-top:0cm;margin-right:6.8pt;margin-bottom:10.0pt;
margin-left:0cm;text-align:justify;mso-pagination:none;mso-layout-grid-align:
none;text-autospace:none"><span lang="EN-US" style="font-size:10.0pt;font-family:
&quot;Arial&quot;,sans-serif;color:black;mso-themecolor:text1">Without limiting the
foregoing, Licensee specifically represents and warrants:<o:p></o:p></span></p><p class="MsoListParagraphCxSpFirst" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">1.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">That the use of the Software does not relieve Licensee of
responsibility for the preparation, content, accuracy (including computational
accuracy), and review of audits prepared by Licensee while using the Software
or any other work product generated by Licensee while using the Software;<o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">2.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee will neither inquire nor rely upon Licensor for
any audit, tax, accounting, legal or other professional or expert advice of any
kind;<o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">3.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee will retrieve in a timely manner any electronic
communications made available to Licensee by Licensor (for example, electronic
filing transaction data such as acknowledgements and e-mail messages in
Licensee’s mailbox); <o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">4.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee is fully and solely responsible for: (a)
selection of adequate and appropriate procedures to satisfy Licensee’s business
needs and achieve its intended results; (b) use of the Software by all users;
(c) all results obtained from the Software; (d) selecting, obtaining and
maintaining all hardware, software, computer capacity, Internet service,
program and system resources and other equipment and utilities needed for
access to and use of the Software, and for all costs associated therewith; and
(e) selection, use of, and results obtained from any other programs,
applications, computer equipment or services used with the Software.&nbsp; Licensee takes full and exclusive
responsibility for complying with and documenting all auditing and
documentation standards of the AICPA and other applicable requirements;<o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">5.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee will not access or use the Software to create
software, a product, service or database that competes with Licensor or the
Software; <o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">6.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee is responsible for complying with all laws,
rules, regulations, and procedures of local, state, federal and foreign
authorities applicable to Licensee and its business, including all laws, rules,
regulations and procedures of the Internal Revenue Code and Service; and <o:p></o:p></span></p><p class="MsoListParagraphCxSpLast" style="margin-top:0cm;margin-right:6.8pt;
margin-bottom:10.0pt;margin-left:36.0pt;mso-add-space:auto;text-align:justify;
text-indent:-18.0pt;mso-pagination:none;mso-list:l0 level1 lfo1;mso-layout-grid-align:
none;text-autospace:none"><!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
Arial;color:black;mso-themecolor:text1">7.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span><!--[endif]--><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:black;
mso-themecolor:text1">Licensee will not upload or transmit any Licensee Data:
(i) that Licensee does not have the lawful right to copy, transmit, distribute,
and display (including any Licensee Data that would violate any confidentiality
or fiduciary obligations that Licensee might have with respect to the Licensee
Data); (ii) for which Licensee does not have the consent or permission from the
owner of any personally identifiable information contained in the Licensee
Data; (iii) that infringes, misappropriates or otherwise violates any
intellectual property or other proprietary rights or violates any privacy
rights of any third party (including any copyright, trademark, patent, trade secret,
or other intellectual property right, or moral right or right of publicity);
(iv) that is false or misleading; (v) that is defamatory, obscene, or
offensive; (vi) if the uploading or transmission would violate, or encourage
any conduct that would violate, any applicable law or regulation or would give
rise to civil or criminal liability or (vii) that constitutes protected health
information under the Health Insurance Portability and Accountability Act
(HIPAA) or any successor law;<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">1.7 Use of Support
Interactions.</span></b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp; If you contact Licensor for support, Licensee
understands and agrees that all interactions with Licensor will be recorded and
may be used to create training and support videos for our own staff and for the
education and assistance of other licensees and users (collectively, “Training
Videos”). Training Videos will be posted or otherwise shared with all licensees
of the Software via a FAQ or other support resource available through the
Software. Licensor will ensure that all Licensee and Licensee client
identifiable data is deleted or obscured in all Training Videos. </span><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif">Licensee
hereby grants to Licensor and its affiliates a non-exclusive, perpetual,
irrevocable, worldwide license to use, sample, collect, and compile Licensee
Data </span><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">included in any Training Videos.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">2. LIMITED
WARRANTY.<o:p></o:p></span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">2.1 Software
Warranty.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Licensor warrants that such Software will: (a)
perform in all material respects in accordance with any documentation and
specification provided by Licensor and (b) be free from material defects in
materials and errors. Licensor will, within thirty (30) days following
Licensor's receipt of written notice and substantiation of any breach of the
aforementioned warranty: (y) correct the warranty breach or (z) provide
Licensee with a plan reasonably acceptable to Licensee for correcting the
breach of warranty. This warranty extends only to Licensee. This warranty shall
not apply to any failure in performance related to accident, abuse,
misapplication, unauthorized modification of the Software or interaction of the
Software programs not furnished by Licensor. Licensor hereby disclaims and any
all warranties, whether express or implied.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">2.2 Malicious
Code.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">To Licensor's knowledge, Licensor warrants that the
Software is free from: (a) all “viruses” and “worms” that could have been
detected (at the date of dispatch, or if appropriate, immediately before
installation); and (b) at the time of delivery to Licensee, all forms of
“malicious electronic repossession” and “logic bombs.”<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">2.3
Representations and Warranties of Licensor.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Licensor hereby represents and warrants to Licensee
that: (a) Licensor and its licensors have good and clear title to the Software,
free and clear of all liens and encumbrances; (b) to Licensor's knowledge, the
use, manufacture, license or copying of the Software by Licensee in accordance
with this Agreement does not infringe any proprietary rights of any third
party; (c) as of the Effective Date, Licensor has not received any notice of
actual or threatened claim(s) from a third party alleging that the Software
infringes any proprietary rights of such third party; and (d) Licensor has the
full power to enter into this Agreement, to carry out its obligations under
this Agreement and to grant the rights and licenses granted to Licensee in this
Agreement.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">3. INDENIFICATION.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Subject to the terms, conditions and limitations of
this Agreement, Licensor will indemnify, defend and hold harmless Licensee
against all resulting damages, losses, costs and liabilities (including
reasonable attorney and professional fees) to the extent resulting or arising
from any claim, suit, demand and action based on a third party claim that the
Software infringes any U.S. patent, copyright or trade secret of such third party,
provided that Licensor is given prompt written notice of such claim. Licensor
shall control such defense with counsel of its choice, and Licensee will fully
cooperate in the defense of such claim, if requested by Licensor. Licensor will
have sole authority to defend or settle the claim. Licensor may, at its sole
option and expense and in addition to its indemnification obligation, (a)
obtain for Licensee the right to continue using the Software, (b) replace or
modify the affected Software so that the Software becomes non–infringing while
giving substantially equivalent functionality, or (c) if such remedies are not
reasonably available, terminate this Agreement. Licensor will have no liability
for infringement claims if the alleged infringement is based on or arises from:
(v) a modification of the Software made by anyone other than Licensor or as
authorized by Licensor, (w) the use of the Software by Licensee to create
materials or data that infringes on third party rights, (x) use that is not in
accordance with Licensor's documentation, if any, (y) use of the Software in a
manner other than as authorized by this Agreement and (z) the unauthorized use
of the Software in conjunction or combination with third–party software.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">4. LIMITATION OF
LIABILITY.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">LICENSOR'S CUMULATIVE, AGGREGATE LIABILITY TO
LICENSOR OR ANY THIRD PARTY HEREUNDER, WHETHER ARISING OUT OF CONTRACT, TORT,
NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, WILL NOT EXCEED $1,000.&nbsp; NOTWITHSTANDING ANYTHING TO THE CONTRARY IN
THIS AGREEMENT, IN NO EVENT WILL LICENSOR, ITS EMPLOYEES, OFFICERS OR
DIRECTORS, AGENTS, SUCCESSORS OR ASSIGNS BE LIABLE TO LICENSEE OR ANY THIRD
PARTY FOR ANY SPECIAL, INCIDENTAL, CONSEQUENTIAL, INDIRECT OR PUNITIVE DAMAGES
ARISING IN ANY WAY OUT OF THE USE OF THE SOFTWARE OR THIS AGREEMENT, INCLUDING
WITHOUT LIMITATION, DAMAGES FOR LOST PROFIT, LOST REVENUE, LOSS OF USE, LOSS OF
DATA, COST OF RECREATING LOST DATA, THE COST OF ANY SUBSTITUTE EQUIPMENT,
PROGRAM OR DATA, WHETHER ARISING OUT OF CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY
OR OTHERWISE REGARDLESS OF WHETHER A PARTY HAS BEEN ADVISED OF THE POSSIBILITY
OF SUCH DAMAGES.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">5. GENERAL
CONDITIONS.<o:p></o:p></span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">5.1 Governing Law.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">The validity, interpretation and enforceability of
this Agreement shall be governed by the exclusive jurisdiction and laws of the
State of Texas without regard to any conflicts of law principles.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">5.2 Relationship.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">This Agreement does not create any joint venture,
partnership or other fiduciary relationship between the parties.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">5.3 Entire
Agreement.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">This Agreement, together with the agreements and
policies expressly incorporated herein by reference, &nbsp;sets forth the entire understanding and
agreement between Licensee and Licensor and supersedes all proposals or
communications, oral or written, between the parties relating to the subject
matter of the Agreement. No modification of the Agreement will be binding
unless it is in writing and is signed by authorized representatives of both
parties.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">5.4 Severability.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">If any provision in this Agreement is invalid or
unenforceable, that provision will be construed, limited, modified or, if
necessary, severed, to the extent necessary, to eliminate its invalidity or
unenforceability, and the other provisions of this Agreement will remain in
full force and effect.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">6. EXPORT CONTROL.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">Any tools, information, documents, or other data or
materials (collectively, “Materials”) available from or through the use of the
Software are or may be subject to United States export controls. No such
Materials may be downloaded, accessed or otherwise exported or re–exported (1)
into any country to which the United States has embargoed goods; or (2) to
anyone on the U.S. Treasury Department's list of Specially Designated Nationals
or the U.S. Commerce Department's Table of Denial Orders or other similar list
(each, a “Restricted List”). By using or downloading any Materials, you are
warranting that you are not located in, under the control of, or a national or
resident of any such country or on any Restricted List.<o:p></o:p></span></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">&nbsp;</span></b></p><p class="MsoNormal"><b><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">7. AMENDMENTS.<o:p></o:p></span></b></p><p class="MsoNormal"><span lang="EN-US" style="font-size: 10pt; font-family: Arial, sans-serif;">This Agreement may be modified by Licensor at any
time, and Licensee's use of the Software after any such amendment shall
constitute Licensee's acceptance of the amended Agreement.<o:p></o:p></span></p><p class="MsoNormal"><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif">&nbsp;</span></p><p>
</p><p class="MsoNormal"><span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif">&nbsp;</span></p>`;
